// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bDiB","rootParamsCollapsed":"styles_rootParamsCollapsed__LEt_w","rootPreviewFull":"styles_rootPreviewFull__3YZ4-","loader":"styles_loader__36VYj"};